import React from 'react';
import { BrowserRouter } from "react-router-dom";
import ReactDOM from 'react-dom/client';
import { library } from '@fortawesome/fontawesome-svg-core';
import './style/index.css';
import App from './components/App';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div className='body-app'>
      <BrowserRouter>      
        <App/>
      </BrowserRouter>
  </div>
  
)
